import Vue from "vue";
import VueRouter from "vue-router";
import { getAccess, userMe } from "../services/brokerService";
import store from "../store/index";
import LandingPage from "../containers/login/LandingPage.vue";
import {isWorkspaceFrame, authenticatedWorkspaceUser, setupWorkspaceHistory} from '@/utils/brokerWorkspaces';

import adminRoutes from "./adminRoutes";
import brokerRoutes from "./brokerRoutes";
import expertRoutes from "./expertRoutes";

Vue.use(VueRouter);

const routes = [
  {
    name: "Landing",
    component: LandingPage,
    path: "/login",
  },
]

const router = new VueRouter({
  mode: isWorkspaceFrame(window) ? 'abstract' : 'history',
  routes
});
setupWorkspaceHistory(router);

router.beforeEach(async (to, from, next) => {
  const logged = store.getters["userState/getLogged"];
  const marketingPath = /^\/(?:karta-marketing|marketing-studio|marketing)(?:\/|$)/.test(to.path);
  const requiredRole = marketingPath ? "alex_admin" : to.matched
    .map((route) => route.meta.requiredRole)
    .find(Boolean);
  if (to.name === "Landing" && !logged) {
    next();
    return;
  }
  if (!logged) {
    store.commit("appState/setLoadingMainData", true);
    store.commit("appState/setEntryUrl", to);
    try {
      let user = authenticatedWorkspaceUser(window);
      if (!user) { await getAccess(); user = await userMe(); }
      if (
        !["alex_admin", "financnik", "znalec"]
          .includes(user.role)
      ) throw {status: 999}
      store.commit("userState/setMe", user);
      store.commit("userState/setLogged", {
        logged: true,
      });
      store.commit("appState/setLoadingMainData", false);
      if (["alex_admin"].includes(user?.role)) {
        router.addRoute(adminRoutes);
      } else if (["financnik"].includes(user?.role)) {
        router.addRoute(brokerRoutes);
      } else if (["znalec"].includes(user?.role)) {
        router.addRoute(expertRoutes);
      }
      if (requiredRole && user.role !== requiredRole) {
        next({name: user.role === "znalec" ? "KartaPosudky" : "KartaHypoteky"});
        return;
      }
      next(to);
      return;
    } catch (e) {
      store.commit("userState/setMe", null);
      store.commit("userState/setLogged", {logged: false});
      next({name: "Landing"});
      return;
    }
  }
  if (logged) {
    if (requiredRole && store.getters["userState/getRole"] !== requiredRole) {
      next({name: store.getters["userState/getRole"] === "znalec" ? "KartaPosudky" : "KartaHypoteky"});
      return;
    }
    next();
  }
});

export default router;
